export class MatrixCalibration {
  probabilityCalibrationId: string;
  consequenceCalibrationId: string;
  riskMatrixProbabilityVectorId: string;
  riskMatrixConsequenceVectorId: string;
}
